import type {AmplitudeOfferPromotionLocation} from "../../../promotion/tracking/get_amplitude_offer_promotion_event_properties";
import type {AmplitudeUnlockChoiceButtonCategory} from "../../../tracking/amplitude/track_amplitude_button_click";
import type {IAmplitudeLeadFormProductData} from "./get_amplitude_lead_form_products";

export type AmplitudeLeadFormLocation =
    | AmplitudeOfferPromotionLocation
    | "listing_page"
    | "homepage_banner"
    | "rp_multilead_review"
    | "rp_multilead_post_lead"
    | "vendor_page"
    | "property_configurator"
    | "listing_map"
    | "post_price_reveal_modal"
    | AmplitudeUnlockChoiceButtonCategory
    | "price_negotiation_modal";

const AMPLITUDE_LEAD_FORM_LOCATIONS: AmplitudeLeadFormLocation[] = [
    "investment_page",
    "property_page",
    "listing_page",
    "homepage",
    "homepage_banner",
    "rp_multilead_review",
    "rp_multilead_post_lead",
    "vendor_page",
    "property_configurator",
    "listing_map",
    "post_price_reveal_modal",
    "rp_post_price_reveal",
    "rp_download_floor_plan",
    "rp_price_history",
    "rp_developer_report",
    "rp_construction_photos",
    "rp_faq",
    "price_negotiation_modal"
];

const isAmplitudeLeadFormLocation = (location: string): location is AmplitudeLeadFormLocation =>
    AMPLITUDE_LEAD_FORM_LOCATIONS.includes(location as AmplitudeLeadFormLocation);

export const getAmplitudeFormLocation = (leadData: IAmplitudeLeadFormProductData | undefined, preferredLocation?: string): AmplitudeLeadFormLocation => {
    if (preferredLocation && isAmplitudeLeadFormLocation(preferredLocation)) {
        return preferredLocation;
    }

    if (leadData?.property?.detail) {
        return "property_page";
    }

    return "investment_page";
};
import type {AmplitudeOfferPromotionLocation} from "../../../promotion/tracking/get_amplitude_offer_promotion_event_properties";
import type {AmplitudeUnlockChoiceButtonCategory} from "../../../tracking/amplitude/track_amplitude_button_click";
import type {IAmplitudeLeadFormProductData} from "./get_amplitude_lead_form_products";

export type AmplitudeLeadFormLocation =
    | AmplitudeOfferPromotionLocation
    | "listing_page"
    | "homepage_banner"
    | "rp_multilead_review"
    | "rp_multilead_post_lead"
    | "vendor_page"
    | "property_configurator"
    | "listing_map"
    | "post_price_reveal_modal"
    | AmplitudeUnlockChoiceButtonCategory
    | "price_negotiation_modal";

const AMPLITUDE_LEAD_FORM_LOCATIONS: AmplitudeLeadFormLocation[] = [
    "investment_page",
    "property_page",
    "listing_page",
    "homepage",
    "homepage_banner",
    "rp_multilead_review",
    "rp_multilead_post_lead",
    "vendor_page",
    "property_configurator",
    "listing_map",
    "post_price_reveal_modal",
    "rp_post_price_reveal",
    "rp_download_floor_plan",
    "rp_price_history",
    "rp_developer_report",
    "rp_construction_photos",
    "rp_faq",
    "price_negotiation_modal"
];

const isAmplitudeLeadFormLocation = (location: string): location is AmplitudeLeadFormLocation =>
    AMPLITUDE_LEAD_FORM_LOCATIONS.includes(location as AmplitudeLeadFormLocation);

export const getAmplitudeFormLocation = (leadData: IAmplitudeLeadFormProductData | undefined, preferredLocation?: string): AmplitudeLeadFormLocation => {
    if (preferredLocation && isAmplitudeLeadFormLocation(preferredLocation)) {
        return preferredLocation;
    }

    if (leadData?.property?.detail) {
        return "property_page";
    }

    return "investment_page";
};
